import { createApi } from '@reduxjs/toolkit/query/react';
import { backendBaseQuery } from '@shared/api';
import { Subscription, CreateSubscriptionDto, UpdateSubscriptionDto } from '../model/types';

export const subscriptionApi = createApi({
  reducerPath: 'subscription-api',
  baseQuery: backendBaseQuery,
  tagTypes: ['Subscription'],
  endpoints: (build) => ({
    findAll: build.query<Subscription[], void>({
      query: () => ({
        url: 'subscriptions',
        method: 'GET'
      }),
      providesTags: [
        {type: 'Subscription', id: 'LIST'}
      ]
    }),

    findOne: build.query<Subscription, string>({
      query: (id) => ({
        url: `subscriptions/${id}`,
        method: 'GET'
      }),
      providesTags: [
        {type: 'Subscription', id: 'ID'}
      ]
    }),

    create: build.mutation<Subscription, CreateSubscriptionDto>({
      query: (body) => ({
        url: 'subscriptions',
        method: 'POST',
        body
      }),
      invalidatesTags: [
        {type: 'Subscription', id: 'LIST'}
      ]
    }),

    update: build.mutation<Subscription, { id: string; body: UpdateSubscriptionDto }>({
      query: ({ id, body }) => ({
        url: `subscriptions/${id}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: [
        {type: 'Subscription', id: 'LIST'},
        {type: 'Subscription', id: 'ID'}
      ]
    }),

    delete: build.mutation<void, string>({
      query: (id) => ({
        url: `subscriptions/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [
        {type: 'Subscription', id: 'LIST'}
      ]
    }),

    toggle: build.mutation<Subscription, { id: string; isEnabled: boolean }>({
      query: ({ id, isEnabled }) => ({
        url: `subscriptions/${id}/toggle`,
        method: 'PUT',
        body: { isEnabled }
      }),
      invalidatesTags: [
        {type: 'Subscription', id: 'LIST'},
      ]
    })
  })
});

export const {
  useFindAllQuery,
  useFindOneQuery,
  useCreateMutation,
  useUpdateMutation,
  useDeleteMutation,
  useToggleMutation
} = subscriptionApi; 